// Shared contact details typography and rhythm.
// Keep this deliberately quiet: the dialog is dense and should read as one system.
export const contactDetailStyles = {
    sectionContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 1.25
    },
    sectionHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        mb: 1.25
    },
    sectionTitle: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        fontSize: { xs: '0.95rem', sm: '1rem' },
        fontWeight: 700,
        lineHeight: 1.35,
        letterSpacing: 0,
        color: 'text.primary',
        m: 0,
        '& .MuiSvgIcon-root': {
            fontSize: '1.05rem',
            color: 'text.secondary'
        }
    },
    subsectionLabel: {
        fontSize: '0.82rem',
        lineHeight: 1.35,
        fontWeight: 700,
        color: 'text.primary',
        letterSpacing: 0,
        m: 0
    },
    itemTitle: {
        fontSize: '0.95rem',
        lineHeight: 1.4,
        fontWeight: 700,
        color: 'text.primary',
        letterSpacing: 0
    },
    itemMeta: {
        fontSize: '0.875rem',
        lineHeight: 1.5,
        fontWeight: 400,
        color: 'text.secondary'
    },
    bodyText: {
        fontSize: '0.95rem',
        lineHeight: 1.65,
        fontWeight: 400,
        color: 'text.primary',
        letterSpacing: 0
    },
    summaryText: {
        fontSize: { xs: '0.95rem', sm: '1rem' },
        lineHeight: 1.72,
        fontWeight: 400,
        color: 'text.primary',
        letterSpacing: 0,
        whiteSpace: 'pre-wrap'
    },
    emptyText: {
        fontSize: '0.875rem',
        lineHeight: 1.5,
        color: 'text.secondary',
        fontStyle: 'italic'
    },
    listItem: {
        py: 0.75,
        alignItems: 'flex-start',
        '& .MuiListItemIcon-root': {
            minWidth: 36,
            color: 'text.secondary',
            pt: 0.15
        }
    },
    noteBlock: {
        mt: 0.75,
        whiteSpace: 'pre-wrap'
    },
    inlineAction: {
        color: 'text.secondary',
        '&:hover': {
            color: 'primary.main',
            bgcolor: 'action.hover'
        }
    },
    softPanel: {
        p: 1.5,
        borderRadius: '8px',
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'action.hover'
    }
};

export const animations = {
    fadeInUp: {
        animation: 'contactDetailsFadeInUp 220ms ease both',
        '@keyframes contactDetailsFadeInUp': {
            from: { opacity: 0, transform: 'translateY(4px)' },
            to: { opacity: 1, transform: 'translateY(0)' }
        },
        '@media (prefers-reduced-motion: reduce)': {
            animation: 'none'
        }
    }
};

export default contactDetailStyles;
